import { useState, useEffect } from 'react';

import { CheckboxProps } from './type';
import Typography from '../Typography';
import { DisabledCheckIcon, EnabledCheckIcon } from './Icons';

import {
  CheckboxWrapper,
  CheckboxInput,
  Checkmark,
  CheckboxLabel,
  DisabledCheckmark,
} from './styled';

const Checkbox = ({ ...props }: CheckboxProps) => {
  const {
    label = '',
    checked,
    onChange,
    disabled,
    id,
    name,
    value,
    highlightedText,
    size = 24,
    fontSize = 14,
    rounded = '6px',
    style,
    labelContainerStyle,
  } = props;
  const [internalChecked, setInternalChecked] = useState<boolean>(checked);

  useEffect(() => {
    setInternalChecked(checked);
  }, [checked]);

  const handleClick = () => {
    if (!disabled) {
      const newChecked = !internalChecked;
      setInternalChecked(newChecked);
      onChange(newChecked);
    }
  };

  return (
    <CheckboxWrapper style={style} onClick={handleClick}>
      <CheckboxInput
        id={id}
        type="checkbox"
        data-testid="checkbox"
        checked={internalChecked}
        onChange={() => {}}
        disabled={disabled}
        name={name}
        value={value}
      />
      {internalChecked ? (
        <Checkmark isChecked={internalChecked} size={size} rounded={rounded}>
          {' '}
          <EnabledCheckIcon size={size} rounded={rounded} />
        </Checkmark>
      ) : (
        <Checkmark isChecked={internalChecked} size={size} rounded={rounded}></Checkmark>
      )}
      {label !== '' && (
        <CheckboxLabel
          htmlFor={id}
          isChecked={internalChecked}
          highlightedText={highlightedText}
          fontSize={fontSize}
          style={labelContainerStyle}
        >
          {disabled ? (
            <>
              <DisabledCheckmark>
                <DisabledCheckIcon size={size} rounded={rounded} />
              </DisabledCheckmark>
              <Typography color="#8E90A4" fontSize={fontSize}>
                {label}
              </Typography>
            </>
          ) : (
            <Typography
              color={
                internalChecked && highlightedText ? 'var(--Azul-primario-500, #0057B8)' : '#5B5D71'
              }
              fontSize={fontSize}
            >
              {label}
            </Typography>
          )}
        </CheckboxLabel>
      )}
    </CheckboxWrapper>
  );
};

export default Checkbox;
